module.exports = __webpack_public_path__ + "img/warning.f40ca961.svg";